export default "__VITE_ASSET__QVm0fmnl__"